import * as ReactRedux from 'react-redux'
import {Action, Dispatch} from "redux"
import {EmploymentHistoryPositionViewProps, CallbackProps, Company, FieldLabels as FieldLabels_, EmploymentHistoryPositionView } from "../components/employmentHistoryView"
import * as Actions from '../actions'
import {CommandCaller} from "../../../lib/commands";
import {AsyncAction} from "../../../lib/types"
import {DatePickerProps} from '../../../lib/sbhtml/datePicker'
import * as $ from 'jquery'
import {SaveEmploymentHistoryPositionResponse} from '../messageTypes'
import {Store} from "react-redux";

export type FieldLabels = FieldLabels_
export type Field = 'startDate'| 'endDate' | 'companyName' | 'companyId' | 'positionTitle'

const dateFormat = 'dd/mm/yy'
export const parseDate = (dateStr: string):Date => {
	return $.datepicker.parseDate(dateFormat, dateStr)
}

export const formatDate = (date: Date): string => {
	return $.datepicker.formatDate(dateFormat, date)
}

export type EmploymentHistoryPositionState = {
	id: number,       // -1 Current contact (uneditable) position, 0 A new unsaved Position, > 0 a persisted Position with rowId = id
	userId: number,
	startDate: string,
	endDate: string,
	companyName: string,
	companyId: number,
	positionTitle: string,
	isSaving: boolean,
	errorFields?:Field[],
	serverErrors?:string[]
}

type EmploymentPositionOwnProps = {
	companies: Company[]
	fieldLabels: FieldLabels
	ajaxPageUrl:string
	datePickerProps: DatePickerProps
	onClose:() => void
	store: Store<EmploymentHistoryPositionState>
}

// state is the current store's state
// ownProps are those explicit properties passed to the react component
// This could also return a function rather than object containing properties. This function will take the store's state and must return props object
const mapStateToProps = (state:EmploymentHistoryPositionState, ownProps:EmploymentPositionOwnProps):EmploymentHistoryPositionViewProps =>
	({
		id: state.id,
		userId: state.userId,
		startDate: parseDate(state.startDate),
		endDate: parseDate(state.endDate),
		companyName: state.companyName,
		companyId: state.companyId,
		positionTitle: state.positionTitle,
		isSaving: state.isSaving,
		companies: ownProps.companies,
		labels: ownProps.fieldLabels,
		datePickerProps: ownProps.datePickerProps,
		errorFields: state.errorFields,
		errorMsgs: state.serverErrors
	})

const validateDate = (dateStr: string):{valid:true, date:Date}|{valid: false} => {
	try {
		const date = parseDate(dateStr)
		const isValid = (date != null)
		return isValid ? {valid: true, date:date} : {valid: false}
	} catch (e) {
		return {valid:false}
	}
}

const doFieldValidation = (state:EmploymentHistoryPositionState): Field[] => {
	let errorFields:Field[] = [];
	if (!state.companyName || !state.companyName.trim()) {
		errorFields.push('companyName');
	}
	const startDateValidity = validateDate(state.startDate)
	const endDateValidity = validateDate(state.endDate)
	if (!startDateValidity.valid) {
		errorFields.push('startDate')
	}
	if (!endDateValidity.valid) {
		errorFields.push('endDate')
	}
	if (startDateValidity.valid 
		&& endDateValidity.valid
		&& startDateValidity.date.getTime() > endDateValidity.date.getTime()
	) {
		errorFields.push('startDate')
		errorFields.push('endDate')
	}

	return errorFields;
}

	
/*
 * The onSave() returns an AsyncAction.
 * There are two definitions of IDispatch - one which accepts simple js object, the other accepts a thunk (some object)
 */
export const onSave = (commandCaller:CommandCaller, onClose:() => void): AsyncAction<Action,EmploymentHistoryPositionState> => {
	return async (dispatch:(_:Actions.BaseAction) => Action, getState:() => EmploymentHistoryPositionState) => {
		let errorFields: Field[] = doFieldValidation(getState());
		if (errorFields.length > 0) {
			dispatch(Actions.actionCreator.field.validateFailure(errorFields))
			return
		}

		dispatch(Actions.actionCreator.server.save())
		const state = getState()
		try {
			const response = await commandCaller.runPost('saveEmploymentHistoryPosition', {
				id: state.id,
				userId: state.userId,
				startDate: state.startDate,
				endDate: state.endDate,
				companyName: state.companyName.trim(),
				companyId: state.companyId,
				positionTitle: state.positionTitle.trim()
			}) as SaveEmploymentHistoryPositionResponse

			if (response.serverErrors.length > 0) {
				dispatch(Actions.actionCreator.server.saveFailure(response.serverErrors))
			} else {
				state.id === 0
					? dispatch(Actions.actionCreator.server.saveAddSuccess(response.id))
					: dispatch(Actions.actionCreator.server.saveUpdateSuccess())
				onClose()
			}
		} catch (e) {
		}
		return
	}
}

const mapDispatchToProps = (dispatch: (a: any) => Action, ownProps: EmploymentPositionOwnProps):CallbackProps => ({
	startDateChanged:(text:string, date:Date) => dispatch(Actions.actionCreator.field.startDateChanged(text, date)),
	endDateChanged:(text:string, date:Date) => dispatch(Actions.actionCreator.field.endDateChanged(text, date)),
	companyNameChanged:(newName:string) => dispatch(Actions.actionCreator.field.changeCompanyName(newName)),
	companyIdChanged:(selectorId:string, newCompany: Company|undefined) => dispatch(Actions.actionCreator.field.changeCompanyId(selectorId, newCompany)),
	positionTitleChanged: (newTitle:string) => dispatch(Actions.actionCreator.field.changePositionTitle(newTitle)),
	onClose:() => ownProps.onClose(),
	onSave: () => {
		return dispatch(onSave(new CommandCaller(ownProps.ajaxPageUrl), ownProps.onClose))
	}
})

export const EmploymentHistoryContainer = ReactRedux.connect<EmploymentHistoryPositionViewProps, CallbackProps, EmploymentPositionOwnProps, EmploymentHistoryPositionState>(
	mapStateToProps,
	mapDispatchToProps
)(EmploymentHistoryPositionView)



// WEBPACK FOOTER //
// ./src/contacts/employmentHistory/containers/index.ts